import React from 'react';
import './Stepper.css';
import {
    BOOKING_STEPS,
    getVisibleSteps,
    isStepNavigationAllowed,
    LandingMode,
    STEP_LABELS,
} from '../../constants/bookingSteps';

interface StepperProps {
    currentStep: number;
    visitedSteps: Set<number>;
    onStepClick: (step: number) => void;
    landingMode: LandingMode;
    showRoomInStepper: boolean;
    includeSummaryStep?: boolean;
}

const PaymentStepIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18" />
        <path d="M7 15h3" />
    </svg>
);

const Stepper: React.FC<StepperProps> = ({
    currentStep,
    visitedSteps,
    onStepClick,
    landingMode,
    showRoomInStepper,
    includeSummaryStep = true,
}) => {
    const steps = getVisibleSteps(includeSummaryStep);

    return (
        <div className="stepper">
            {steps.map((step) => {
                const isVisited = visitedSteps.has(step);
                const isClickable = isVisited && isStepNavigationAllowed(step, landingMode, showRoomInStepper);
                const isPaymentStep = step === BOOKING_STEPS.PERSONAL_DATA;

                return (
                    <div
                        key={step}
                        className={[
                            'step',
                            currentStep === step ? 'active' : '',
                            isVisited ? 'visited' : '',
                            isVisited && !isClickable ? 'locked' : '',
                            isPaymentStep ? 'step--payment' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => {
                            if (isClickable) {
                                onStepClick(step);
                            }
                        }}
                        title={STEP_LABELS[step]}
                        aria-label={STEP_LABELS[step]}
                    >
                        {isPaymentStep ? <PaymentStepIcon /> : step}
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
